
/*
 * Filename: lookup-filter-rule.controller.ts
 * Description: Controller for lookup filter rule
 */

import { CQAppConstant } from '../../../app-constants';

export class CQLookupFilterRuleController {
    public ruleJSON: any = {};

    constructor(ruleObject: any) {
        this.formRuleJson(ruleObject);
    }

    /**
     * @private
     * @memberof CQFormulaFieldRuleController
     */
    private formRuleJson = (lookupFilterRuleData: any) => {
        let lookupFilterRule: any = this.formRuleFilter(lookupFilterRuleData);
        lookupFilterRule = { [`lookup filter`]: lookupFilterRule };
        this.ruleJSON = lookupFilterRule;
        return this.ruleJSON;
    }

    /**
    * @memberof CQFormulaFieldRuleController
    */
    public formRuleFilter = (lookupFilterRuleData: any) => {

        const lookupFilterRuleObj = { ...lookupFilterRuleData.rootGroup };
        
        lookupFilterRuleObj.fields = [];
        if (lookupFilterRuleObj.hasOwnProperty('selectedReferenceFields')) {
            delete lookupFilterRuleObj['selectedReferenceFields'];
        }
        
        lookupFilterRuleObj.filters.map((filter: any) => {

            if (filter.hasOwnProperty('field')) {
                const dynamicValue = filter.dynamicValue;
                this.formatDynamicKeyBasedOnType(filter);
                if (filter.isDynamic) {
                    lookupFilterRuleObj.fields.push(dynamicValue);
                }
                if (filter.hasOwnProperty('selectedFieldType')) {
                    delete filter['selectedFieldType'];
                }
            }
            if (!filter.hasOwnProperty('field')) {
                this.interateOverNestedFilters(filter.filters, lookupFilterRuleObj);
            }

        });
        if (lookupFilterRuleObj.fields.length > 0) {
            lookupFilterRuleObj.fields = Array.from(new Set(lookupFilterRuleObj.fields));
        } else {
            lookupFilterRuleObj.fields = [];
        }
        return lookupFilterRuleObj;
    }

    private readonly interateOverNestedFilters = (filters: any, lookupFilterRuleObj: any) => {
        filters.forEach((groupFilterRule: any) => {
            if (groupFilterRule.hasOwnProperty('field')) {
                const dynamicValue = groupFilterRule.dynamicValue;
                this.formatDynamicKeyBasedOnType(groupFilterRule);
                if (groupFilterRule.isDynamic) {
                    lookupFilterRuleObj.fields.push(dynamicValue);
                }
                if (groupFilterRule.hasOwnProperty('selectedFieldType')) {
                    delete groupFilterRule['selectedFieldType'];
                }
            }
            if (!groupFilterRule.hasOwnProperty('field')) {
                this.interateOverNestedFilters(groupFilterRule.filters, lookupFilterRuleObj);
            }
        });
    }

    private readonly formatDynamicKeyBasedOnType = (criteria: any) => {
        const keyNameStaticValue = criteria.isDynamic ? 'dynamicValue' : 'value';
        const dynamicValue = criteria.dynamicValue;
        let referenceField = '';
        if (criteria.hasOwnProperty('referenceField')) {
            referenceField = criteria['referenceField'];
        }
        this.deleteReferenceKeys(criteria);
        switch (criteria.selectedFieldType) {
            case 'boolean':
                criteria[keyNameStaticValue] = dynamicValue ? 'true' : 'false';
                break;
            case 'reference':
                criteria['usv_function'] = criteria.selectedFieldType;
                criteria['usv_param'] = referenceField;
                criteria[keyNameStaticValue] = dynamicValue;
                break;
            case 'datetime':
                criteria[keyNameStaticValue] = new Date(dynamicValue).toISOString();
                break;
            default:
                criteria[keyNameStaticValue] = dynamicValue;
                break;
        }
    }


    /**
     * @private
     * @memberof CQLookupFilterRuleController
     */
    private readonly deleteReferenceKeys = (criteriaData: any) => {
        if (criteriaData.hasOwnProperty('usv_function')) {
            delete criteriaData['usv_function'];
        }
        if (criteriaData.hasOwnProperty('usv_param')) {
            delete criteriaData['usv_param'];
        }
        if (criteriaData.hasOwnProperty('referenceField')) {
            delete criteriaData['referenceField'];
        }
        if (criteriaData.hasOwnProperty('value')) {
            delete criteriaData['value'];
        }
        if (criteriaData.hasOwnProperty('dynamicValue')) {
            delete criteriaData['dynamicValue'];
        }
        return criteriaData;
    }


}

